module.exports = "export default __webpack_public_path__ + &quot;1a0095a645ed53e44f573cd007b7a60b.svg&quot;;"